export default __webpack_public_path__ + "static/bg-stats-f0c6952f66f2a24365bec7534eb51fab.jpg";